import { render, staticRenderFns } from "./RestaurantTabsReservations.vue?vue&type=template&id=5201fb0c&scoped=true&"
import script from "./RestaurantTabsReservations.vue?vue&type=script&lang=js&"
export * from "./RestaurantTabsReservations.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantTabsReservations.vue?vue&type=style&index=0&id=5201fb0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5201fb0c",
  null
  
)

export default component.exports